import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedUnitInfoCardComponent } from "./med-unit-info-card.component";

@NgModule({
  declarations: [
    MedUnitInfoCardComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedUnitInfoCardComponent,
  ],
})
export class MedUnitInfoCardModule { }
